import React from 'react';
import compose from 'recompose/compose';
import { getThreadById } from 'shared/graphql/queries/thread/getThread';

import Attachment from './attachment';

const Query = ({ data, message, id, ...rest }) => (
  <Attachment message={message} id={id} data={data} />
);

const ThreadAttachment = compose(getThreadById)(Query);

export default ThreadAttachment;
